// extracted by mini-css-extract-plugin
module.exports = {"app":"Layout_app_33gBz"};